import React from "react";
import { CloseOutlined } from "@ant-design/icons";

interface ErrorNotificationProps {
  title?: string;
  message: string;
}

const ErrorNotification: React.FC<ErrorNotificationProps> = ({
  title = "Error",
  message,
}) => {
  return (
    <div 
      className="px-6 py-4 rounded-3xl outline outline-1 outline-offset-[-1px] inline-flex flex-col justify-start items-start gap-1.5"
      style={{
        backgroundColor: '#FEF2F2', // Background-Semantic-Error-Subtle
        outlineColor: '#EF4444', // Border-Semantic-Error-Primary
      }}
    >
      <div className="self-stretch inline-flex justify-start items-center gap-3">
        <div
          data-property-1="Default"
          className="w-6 h-6 rounded-full flex justify-center items-center"
          style={{
            backgroundColor: '#EF4444', // Background-Semantic-Error-Bold
            padding: '10px',
          }}
        >
          <CloseOutlined style={{ fontSize: '16px', color: '#fff' }} />
        </div>
        <div className="justify-start text-base font-normal font-['Inter'] leading-8" style={{ color: 'rgba(10, 10, 10, 0.9)' }}>
          {title}
        </div>
      </div>
      <div className="self-stretch justify-start text-base font-normal font-['Inter'] leading-8" style={{ color: 'rgba(10, 10, 10, 0.9)' }}>
        {message}
      </div>
    </div>
  );
};

export default ErrorNotification;

